module.exports = __webpack_public_path__ + "static/media/portfolio1 (46).57d0401f.jpeg";